import React, { Component } from 'react'
import Banner from '../../components/tribe/tribe_banner2'
import './css/index.css'
import Navbar from '../../components/navbar'
import Footer from '../../components/footer' 
import blendedimage from '../../assets/image/Learning/blended.jpg'
export default class blended extends Component {
    render() {
        const image=[
            {image:blendedimage}
        ]
        return (
            <div>
                <Navbar/>
                <br/><br/><br/><br/><br className='hide-mobile'/><br className='hide-mobile'/>
                <div className='learning-section'>
                    <Banner bread_crum={['Learning','Blended Learning']} image={image} title="Blended Learning" subtitle=""/>
                    <br/><br/>
                    <div className='learning-content'>
                        <h2>How we work</h2>
                        <br/><br/>
                        <div className='how'>
                            <p>
                                Training should not be a one-time activity. To ensure its effectiveness, researches have shown that Pre-Training Activities and Post-Training Activities play very significant roles.
                                <br/><br/>
                                Lutan Edukasi is utilizing a blended learning approach to ensure the optimal return on your training investment. We start with Pre-Training Activities to establish the baseline and set the participants on the right track on their development. These activities may include Pre-Reading, Focus Group Discussion to explore the areas for development, or a 360 Degree Pre-Assessment to measure the current level of competencies among the participants.
                                <br/><br/>
                                The Training Execution will develop the competencies of the participants through interactive sessions and various learning activities, and the Post-Training Activities will ensure the transfer of learning to the workplace. A 360 Degree Post-Assessment can be utilized to measure the progress after attending the workshop. The Reporting in the final phase will measure the progress and the effectiveness of the whole process.
                                <br/><br/>
                                A highly-customizable Blended Learning Solution from Lutan Edukasi will make sure that the skills in the in-class workshops will be kept alive and implemented in their day-to-day activities to meet your organization’s needs.
                            </p>
                        </div>
                    </div>
                </div>
                <br/><br/>
                <Footer/>
            </div>
        )
    }
}
